import { render, staticRenderFns } from "./CodesInfo.vue?vue&type=template&id=0fc96974"
import script from "./CodesInfo.vue?vue&type=script&lang=js"
export * from "./CodesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports